import { SvgIcon } from "@mui/material";
import { WHITE_LABEL_COLORS } from "../../theme/colors";

interface IRadioIconProps {
    className?: string;
}

export const RadioUncheckedIcon = ({ className }: IRadioIconProps) => {
    return (
        <SvgIcon className={className} viewBox="0 0 24 24">
            <circle cx="12" cy="12" fill={WHITE_LABEL_COLORS.white} r="9" stroke="currentColor" strokeWidth="2" />
        </SvgIcon>
    );
};

export const RadioCheckedIcon = ({ className }: IRadioIconProps) => {
    return (
        <SvgIcon className={className} viewBox="0 0 24 24">
            <circle cx="12" cy="12" fill={WHITE_LABEL_COLORS.white} r="9" stroke="currentColor" strokeWidth="2" />
            <circle cx="12" cy="12" fill="currentColor" r="5" />
        </SvgIcon>
    );
};
